import createRouter from '@updater/app-shell';
import { BASE_PATH } from './home-security.config';
import { ITEM_STATUSES } from '../../../constants/items';

export const CONTENT_SLOT = 'OFFERS-CONTENT-SLOT';
const redirectToLandingPageIfStatusIsNotReserved = (_, { getStatus }) => {
  if (getStatus() !== ITEM_STATUSES.RESERVED) {
    return '/';
  }

  return false;
};

const redirectToReservedPageIfStatusIsReserved = (_, { getStatus }) => {
  if (getStatus() === ITEM_STATUSES.RESERVED) {
    return '/reserved';
  }

  return false;
};

const routes = {
  '/': {
    components: {
      [`#${CONTENT_SLOT}`]: 'landing-page',
    },
    data: {
      analytics: {
        event: 'landing',
      },
    },
    redirects: [redirectToReservedPageIfStatusIsReserved],
  },
  '/reserved.*': {
    components: {
      [`#${CONTENT_SLOT}`]: 'reserved',
    },
    data: {
      analytics: {
        event: 'reserved',
      },
    },
    redirects: [redirectToLandingPageIfStatusIsNotReserved],
  },
};

export function initializeRouter(element, value) {
  return createRouter(
    {
      basePath: BASE_PATH,
      dynamicComponentImport: path => {
        return import(/* webpackChunkName: "[request]" */ `HOME-SECURITY-REPLACE-ME/${path}.js`);
      },
      element,
      routes,
    },
    value
  );
}
